package search.searchlayer

import analyticsdashboard.AnalyticsTimeFilterStore
import apiclient.FormationClient
import apiclient.geoobjects.Bbox
import apiclient.geoobjects.GeoObjectDetails
import apiclient.geoobjects.LatLon
import apiclient.geoobjects.ObjectType
import apiclient.geoobjects.SearchQueryContext
import apiclient.geoobjects.restSearchForIds
import apiclient.groups.Group
import apiclient.groups.LayerStatus
import apiclient.markers.MapLayerContext
import apiclient.tags.isDeleted
import apiclient.util.formatIsoDate
import apiclient.util.isNotNullOrEmpty
import apiclient.util.withDuration
import auth.ApiUserStore
import data.users.settings.LocalSettingsStore
import dev.fritz2.core.RootStore
import dev.fritz2.core.SimpleHandler
import dev.fritz2.core.invoke
import dev.fritz2.routing.MapRouter
import dev.fritz2.tracking.tracker
import generated.ServerConfig
import koin.koinCtx
import koin.withKoin
import kotlin.coroutines.EmptyCoroutineContext
import kotlin.time.Duration.Companion.seconds
import kotlin.time.measureTimedValue
import kotlinx.coroutines.CoroutineName
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.cancel
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.conflate
import kotlinx.coroutines.flow.debounce
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.mapNotNull
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.serialization.builtins.serializer
import layercache.GeoObjectDetailsCache
import layercache.LayerCache
import layercache.LayerCache.Companion.searchLayers
import layercache.getLayerClients
import localstorage.LocalStoringStore
import mainmenu.AppStateStore
import mainmenu.Pages
import mainmenu.PeriodicSearchTimeUnitStore
import mainmenu.PeriodicSearchTimeValueStore
import map.MapLayerUserSettingsStore
import map.MapStateStore
import maplibreGL.FormationMap
import mapsearch.historyPathTool.ObjectHistoryResultsCache
import model.AppPhase
import model.LocalSettings
import model.MapState
import model.SearchContexts
import model.manualSearch
import model.mapSearch
import model.periodicSearch
import network.NetworkState
import network.NetworkStateStore
import search.SearchContextsStore
import search.hasUserAndGroupIds
import utils.getMapLayersToClean
import utils.insertObjectsInCachesAndUpdateRenderedObjectsOnMap
import utils.parseInstant
import utils.removeObjectsInCachesAndMap

class SyncTimestampStore : LocalStoringStore<String>("", "", "last-synced", String.serializer()) {
    fun getLastSynced(): Instant? {
        // FIXME unused?
        return current.takeIf { it.isNotNullOrEmpty() }?.parseInstant()
    }

    fun markLastSynced() {
        // FIXME unused?
        update(Clock.System.now().formatIsoDate())
    }

}

class MapSearchClientsStore : RootStore<List<LayerCache>>(
    initialData = emptyList(),
    job = Job(),
) {

    private val syncTimestampStore = SyncTimestampStore()
    private val router: MapRouter by koinCtx.inject()
    val apiUserStore: ApiUserStore by koinCtx.inject()
    val formationClient: FormationClient by koinCtx.inject()
    private val searchContextsStore: SearchContextsStore by koinCtx.inject()
    private val mapStateStore: MapStateStore by koinCtx.inject()
    private val localSettingsStore: LocalSettingsStore by koinCtx.inject()
    private val searchManually = localSettingsStore.map(LocalSettings.manualSearch())
    private val networkStateStore: NetworkStateStore by koinCtx.inject()
    private val mapSearchResultsStore: MapSearchResultsStore by koinCtx.inject()
    private val geoObjectDetailsCache: GeoObjectDetailsCache by koinCtx.inject()
    private val objectHistoryResultsCache: ObjectHistoryResultsCache by koinCtx.inject()
    private val analyticsTimeFilterStore: AnalyticsTimeFilterStore by koinCtx.inject()

    val mapSearchTracker = tracker(debounceTimeout = 800)

    val reset = handle {
        console.log("Reset MapSearchClientsStore")
        emptyList()
    }

    val updateMapSearchClients = handle<List<Group>?> { current, groups ->
        // FIXME remove
        current
    }

    val triggerMapSearchManually = handle { current ->
        mapSearch(null)

        mapStateStore.resetMovedState()
        current
    }

    private var searchJob: Job? = null

    fun cancelSearch() {
        if (searchJob?.isActive == true) {
            searchJob?.cancel()
            console.warn("Cancelling search.")
        }
        searchJob = null
    }

    val mapSearch = SimpleHandler<MapState?> { data, _ ->
        // FIXME remove this

//        data handledBy { mapState ->
//
//            val appStateStore by koinCtx.inject<AppStateStore>()
//            val newMapState = mapState ?: mapStateStore.current
//            val online = networkStateStore.current == NetworkState.Online
//            val loggedIn =
//                appStateStore.current.appPhase.let { it == AppPhase.LoggedIn || it == AppPhase.LoggedInAnonymous }
//
//        }
    }

    val invalidateLayerCaches = handle<ObjectType> { current, objType ->
        val layerCaches = current.filter { it.layerId in objType.getMapLayersToClean() }
        layerCaches.forEach { cache -> cache.clear() }
        console.log("Cache(s) cleared for:", layerCaches.map { it.layerId }.toString())
        mapSearch(null)
        current
    }

    fun clearAllLayerCaches() {
        current.forEach { layerCache ->
            layerCache.clear()
        }
    }

    fun insertId(id: String, latLon: LatLon) {
        current.forEach { layerCache ->
            layerCache.insertId(
                id = id,
                latLon = latLon,
                mapLayerContext = searchContextsStore.current.mapSearch,
            )
        }
    }

    private val mapPageListener = SimpleHandler<Map<String, String>> { routeData, _ ->
        routeData handledBy { route ->
            if (route.keys.size <= 2 && route["ws"] != null
                && route["page"] == Pages.Map.name
            ) {
                console.log("mapPageListener triggered search")
                mapSearch(null)
            }
        }
    }


    private suspend fun syncChangedSince(
        changedAfter: Instant,
        formationClient: FormationClient,
//            layerCaches: List<LayerCache>,
//            bbox: Bbox,
        mapLayerContext: MapLayerContext,
        includeDeleted: Boolean = false,
        onUpdate: suspend (Pair<List<GeoObjectDetails>, Set<String>>) -> Unit = {}
    ) = coroutineScope {
        val searchContext = SearchQueryContext(
            groupIds = mapLayerContext.groupIds,
            changedAfter = changedAfter.toString(),
            includeDeleted = includeDeleted,
        )
        val result = formationClient.restSearchForIds(searchContext)

        when {
            result.isSuccess -> {
                try {
                    val changedIds = result.getOrThrow().hits
                    if (changedIds.isNotEmpty()) {
                        val updatedObjects = measureTimedValue {
                            geoObjectDetailsCache.multiGet(
                                ids = changedIds,
                                formationClient = formationClient,
                                forceUpdate = true,
                            )
                        }.withDuration {
                            console.info("sync-changes multiget took $duration")
                        }.filterNot { it.tags.isDeleted } // filter out deleted objects
                        val deletedIds = changedIds.toSet() - updatedObjects.map { it.id }.toSet()
                        onUpdate(updatedObjects to deletedIds)
                    } else {
                    }
                } catch (e: Throwable) {
                    console.error("sync-changes failed", e.message, e.stackTraceToString())
                }
            }

            else -> {
                console.warn("sync-changes failed")
                console.warn("sync-changes failed", result.exceptionOrNull()?.stackTraceToString())
            }
        }
    }

    private suspend fun doSync(
        changedAfter: Instant
    ) {
        val appStateStore by koinCtx.inject<AppStateStore>()
        val mapState = mapStateStore.current ?: return
        if (mapState.tl == null || mapState.br == null) {
            return
        }
        val online = networkStateStore.current == NetworkState.Online
        val loggedIn =
            appStateStore.current.appPhase.let { it == AppPhase.LoggedIn || it == AppPhase.LoggedInAnonymous }

        if (online && loggedIn) {
            syncChangedSince(
                formationClient = formationClient,
                mapLayerContext = searchContextsStore.current.mapSearch,
                changedAfter = changedAfter,
                includeDeleted = true,
            ) { (newObjects, deletedIds) ->
                removeObjectsInCachesAndMap(deletedIds)
                // update only objects that are on the map already,
                // new objects are not inserted as they cant be checked easily
                // if they should be displayed or part of a disabled map layer
                insertObjectsInCachesAndUpdateRenderedObjectsOnMap(newObjects)

                if (newObjects.isNotEmpty() || deletedIds.isNotEmpty()) {
                    withKoin {
                        console.log("syncing map")
                        get<FormationMap>().syncMarkersNow()
                    }
                    console.info("updated object(s): " + newObjects.size + " deleted object(s): ${deletedIds.size}")
                }
            }
        }
    }
}

class PeriodicSearchStore : RootStore<Job?>(
    initialData = null,
    job = Job(),
) {
    private val periodicSearchTimeUnitStore by koinCtx.inject<PeriodicSearchTimeUnitStore>()
    private val periodicSearchTimeValueStore by koinCtx.inject<PeriodicSearchTimeValueStore>()
    private val mapSearchClientsStore by koinCtx.inject<MapSearchClientsStore>()
    private val localSettingsStore by koinCtx.inject<LocalSettingsStore>()
    private val periodicSearch = localSettingsStore.map(LocalSettings.periodicSearch())

    val initialize = handle { it }

    private val startPeriodicSearch = handle { searchJob ->
        if (searchJob != null && searchJob.isActive) {
            console.log("Periodic search is already active")
            searchJob
        } else {
            console.log("Start search periodically every ${periodicSearchTimeValueStore.current} ${periodicSearchTimeUnitStore.current.name.lowercase()}")
            val periodicSearchJob = CoroutineScope(CoroutineName("auto-search")).launch {
                while (true) {
                    // Validate input duration. Make sure duration is >= 1 second
                    val durationSetting =
                        periodicSearchTimeUnitStore.current.asDuration(periodicSearchTimeValueStore.current)
                    val delayDuration = if (durationSetting >= 1.seconds) durationSetting else 1.seconds
                    delay(delayDuration)
                    console.log("auto search (every ${periodicSearchTimeValueStore.current} ${periodicSearchTimeUnitStore.current.name.lowercase()})")
                    mapSearchClientsStore.mapSearch(null)
                }
            }
            periodicSearchJob
        }
    }

    private val stopPeriodicSearch = handle { current ->
        current?.let {
            console.log("Stop periodic search")
            it.cancel("Stop periodic search by user")
            null
        }
    }

    private val handleSetting = handle<Boolean> { current, setting ->
        if (setting) startPeriodicSearch() else stopPeriodicSearch()
        current
    }

    private val changeInterval = handle { current ->
        if (current != null) {
            console.log("Restart periodic search")
            current.cancel("Stop periodic search by user")
            startPeriodicSearch()
        }
        current
    }

    init {
        console.log("PeriodicSearchStore initialized")
        periodicSearch.data handledBy handleSetting
        periodicSearchTimeValueStore.data.combine(periodicSearchTimeUnitStore.data) { value, unit ->
            // Validate input duration. Make sure duration is >= 1 second
            if (unit.asDuration(value) >= 1.seconds) Unit else null
        }.mapNotNull { it } handledBy changeInterval

    }
}
